import { render } from "./ContractConfirm.vue?vue&type=template&id=5a47de82&scoped=true"
import script from "./ContractConfirm.vue?vue&type=script&lang=js"
export * from "./ContractConfirm.vue?vue&type=script&lang=js"

import "./ContractConfirm.vue?vue&type=style&index=0&id=5a47de82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a47de82"]])

export default __exports__